import CHATBOT_TYPES from './_actionTypes';

const initialState = {
  isOpen: false,
  messages: [],
  isTyping: false,
  error: null,
  sessionId: null,
  rateLimit: null,       // { daily_limit, remaining }
  rateLimitExceeded: false,
  chatbotDisabled: false,
};

const chatbotReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHATBOT_TYPES.CHATBOT_OPEN:
      return { ...state, isOpen: true };

    case CHATBOT_TYPES.CHATBOT_CLOSE:
      return { ...state, isOpen: false };

    case CHATBOT_TYPES.CHATBOT_TOGGLE:
      return { ...state, isOpen: !state.isOpen };

    case CHATBOT_TYPES.SEND_MESSAGE_REQUEST:
      return {
        ...state,
        messages: [
          ...state.messages,
          {
            id: Date.now(),
            role: 'user',
            text: action.payload.message,
            timestamp: new Date().toISOString(),
          },
        ],
        error: null,
      };

    case CHATBOT_TYPES.BOT_TYPING_START:
      return {
        ...state,
        isTyping: true,
        messages: [
          ...state.messages,
          {
            id: Date.now() + 1,
            role: 'bot',
            text: '',
            isStreaming: true,
            timestamp: new Date().toISOString(),
          },
        ],
      };

    case CHATBOT_TYPES.APPEND_BOT_TOKEN: {
      const msgs = [...state.messages];
      const lastIdx = msgs.length - 1;
      if (lastIdx >= 0 && msgs[lastIdx].role === 'bot') {
        msgs[lastIdx] = {
          ...msgs[lastIdx],
          text: msgs[lastIdx].text + action.payload.token,
        };
      }
      return { ...state, messages: msgs };
    }

    case CHATBOT_TYPES.BOT_TYPING_STOP: {
      const msgs = [...state.messages];
      const lastIdx = msgs.length - 1;
      if (lastIdx >= 0 && msgs[lastIdx].role === 'bot') {
        msgs[lastIdx] = { ...msgs[lastIdx], isStreaming: false };
      }
      return { ...state, isTyping: false, messages: msgs };
    }

    case CHATBOT_TYPES.SEND_MESSAGE_SUCCESS:
      return { ...state, isTyping: false };

    case CHATBOT_TYPES.SEND_MESSAGE_FAILURE:
      return { ...state, isTyping: false, error: action.payload?.error || 'Something went wrong' };

    case CHATBOT_TYPES.UPDATE_RATE_LIMIT:
      return {
        ...state,
        rateLimit: action.payload,
        rateLimitExceeded: action.payload.remaining === 0,
      };

    case CHATBOT_TYPES.RATE_LIMIT_EXCEEDED:
      return {
        ...state,
        rateLimitExceeded: true,
        rateLimit: { daily_limit: action.payload.daily_limit, remaining: 0 },
        error: action.payload.message,
      };

    case CHATBOT_TYPES.CHATBOT_DISABLED:
      return { ...state, chatbotDisabled: true };

    case CHATBOT_TYPES.CLEAR_HISTORY:
      return { ...state, messages: [], sessionId: null };

    default:
      return state;
  }
};

export default chatbotReducer;
